import React from 'react';
import { useSearchParams } from 'react-router-dom';
import IELTSCourse from '../courses/IELTSCourse';
import { individualWordsData, getDataForDifficulty } from '../courses/data/vocabulary/individualWords';

export default function IndividualWordsTips() {
  const [searchParams] = useSearchParams();
  const lessonId = searchParams.get('lessonId');
  const difficulty = parseInt(searchParams.get('difficulty')) || 3;

  return (
    <IELTSCourse
      {...(difficulty !== 3 ? getDataForDifficulty(difficulty) : individualWordsData)}
      lessonId={lessonId}
      difficulty={difficulty}
    />
  );
}
